






































































































































// vendor
import { defineComponent, computed, ref, onMounted, onUnmounted } from "@vue/composition-api";
// project
import { useUserPrefs } from "@/hooks/useUserPrefs";
// local
import { useTagManager } from "./useTagManager";

export default defineComponent({

	emits:[
		"tag-item"
	],
	props:{
		showAdd:{
			type:Boolean,
			default:true
		}
	},
	setup(props, context){

		const {
			tagsCollapsed:collapsed
		} = useUserPrefs();

		const {
			sortedTags,
			handleTagDrop,
			dropTarget,
			openTagContext,
			createTag
		} = useTagManager({
			context,
		});

		const activeTag = computed(() => {
			const t = context.root.$route.query["t"];
			return t;
		});

		const selectTag = (id:string) => {
			if(activeTag.value === id){ return; }
			setRouteTag(id);
		};

		const setRouteTag = (tag:string|null|undefined) => {
			const q:any = { ...context.root.$route.query };
			if(tag){
				q["t"] = tag;
			}
			else {
				delete q["t"];
			}
			context.root.$router.push({ query: q})
			.catch(() => {});
		};

		const toggleCollapsed = () => {
			collapsed.value = !collapsed.value;
		};

		return {
			collapsed,
			dropTarget,
			activeTag,
			createTag,
			selectTag,
			sortedTags,
			handleTagDrop,
			openTagContext,
			toggleCollapsed,
		};
	}
});

